import {Card, Row, Col, Modal, InputNumber, Divider} from 'antd';
import {useState} from 'react';

export const PackagingCard = ({item, onCostChange, props}) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [cost, setCost] = useState(item.cost);
    const [tariff, setTariff] = useState(item.tariff);
    const [shipping, setShipping] = useState(item.shipping);
    const [startQuantity, setStartQuantity] = useState(item.startQuantity);

    const labelStyle = {
        width: 150,
        fontWeight: 'bold',
    }
    const valueStyle = {
    }

    const modalLabelStyle = {
        width: 150,
        fontWeight: 'bold',
        marginTop: '5px'
    }

    const rowStyle = {
        marginTop: '5px',
        marginBottom: '5px'
    }

    const toUsd = (val) => {
        return `$ ${val}`;
    }

    const onCostClick = () => {
        setModalOpen(true);
    }

    const onOk = () => {
        if (onCostChange) {
            onCostChange({
                tariff, shipping, startQuantity, cost
            })
        }
        setModalOpen(false);
    }

    const onCancel = () => {
        setModalOpen(false);
        setCost(item.cost);
        setShipping(item.shipping);
        setTariff(item.tariff);
        setStartQuantity(item.startQuantity);
    }

    const onCostValueChange = (val) => {
        setCost(val);
    }

    const onShippingChange = (val) => {
        setShipping(val);
    }

    const onTariffChange = (val) => {
        setTariff(val);
    }

    const onQuantityChange = (val) => {
        setStartQuantity(val);
    }

    const totalCost = item.cost + item.tariff + item.shipping;
    const unitCost = (totalCost / item.startQuantity).toFixed(2);

    return <Card title={<div><b>Cost Basis</b></div>} width={400}>
        <Modal title={`Set Cost Basis for ${item.name}`} open={modalOpen} onOk={onOk} onCancel={onCancel}>
            <Divider />
            <Row style={rowStyle}>
                <Col style={modalLabelStyle}>Cost:</Col>
                <Col style={valueStyle}><InputNumber addonBefore={'$'} value={cost} onChange={onCostValueChange} precision={2} /></Col>
            </Row>
            <Row style={rowStyle}>
                <Col style={modalLabelStyle}>Shipping:</Col>
                <Col style={valueStyle}><InputNumber addonBefore={'$'} value={shipping} onChange={onShippingChange} precision={2} /></Col>
            </Row>
            <Row style={rowStyle}>
                <Col style={modalLabelStyle}>Tariff:</Col>
                <Col style={valueStyle}><InputNumber addonBefore={'$'} value={tariff} onChange={onTariffChange} precision={2} /></Col>
            </Row>
            <Row style={rowStyle}>
                <Col style={modalLabelStyle}>Start Quantity:</Col>
                <Col style={valueStyle}><InputNumber value={startQuantity} onChange={onQuantityChange} precision={2} /></Col>
            </Row>
        </Modal>
        <Row>
            <Col style={labelStyle}>Cost:</Col>
            <Col style={valueStyle}><div onClick={onCostClick} style={{cursor: 'pointer', color: "#108ee9"}}>{toUsd(item.cost)}</div></Col>
        </Row>
        <Row>
            <Col style={labelStyle}>Shipping:</Col>
            <Col style={valueStyle}>{toUsd(item.shipping)}</Col>
        </Row>
        <Row>
            <Col style={labelStyle}>Tariff:</Col>
            <Col style={valueStyle}>{toUsd(item.tariff)}</Col>
        </Row>
        <Row>
            <Col style={labelStyle}>Total Cost:</Col>
            <Col style={valueStyle}>{toUsd(totalCost)}</Col>
        </Row>
        <Row>
            <Col style={labelStyle}>Start Quantity:</Col>
            <Col style={valueStyle}>{item.startQuantity}</Col>
        </Row>
        <Row>
            <Col style={labelStyle}>Unit Cost:</Col>
            <Col style={valueStyle}>{toUsd(unitCost)}</Col>
        </Row>
    </Card>
}